export { default as SelectedProductsModalHeader } from './SelectedProductsModalHeader';
